import getJWTs from './get-jwts';
import getFinancoAccessTokens from './get-financo-access-tokens';

function refreshMicroSimulators() {
    const microSimulatorEls = [...document.querySelectorAll('.financo-micro-simulator:not(.financo-micro-simulator--loading):not(.financo-micro-simulator--fetched)')];

    if(microSimulatorEls.length) {
        let microSimulatorsData = {};

        microSimulatorEls.forEach((el) => {
            const data = {
                id: el.hasAttribute('id') ? el.getAttribute('id') : null,
                price: el.hasAttribute('data-price') ? el.getAttribute('data-price') : null,
                registerDate: el.hasAttribute('data-register-date') ? el.getAttribute('data-register-date') : null,
                name: el.hasAttribute('data-name') ? el.getAttribute('data-name') : null,
                brand: el.hasAttribute('data-brand') ? el.getAttribute('data-brand') : null,
                has_vat: el.hasAttribute('data-has-vat') ? el.getAttribute('data-has-vat') : null
            };

            el.classList.add('financo-micro-simulator--loading');
            
            if(data.id !== null && data.price !== null && data.registerDate !== null && data.name !== null && data.brand !== null && data.has_vat !== null) {
                microSimulatorsData[data.id] = data;
            }
        });
        
        if(Object.keys(microSimulatorsData).length) {
            getJWTs(finm.jwt_tokens_nonce, finm.ajax_url, microSimulatorsData)
                // Appel à l'API Financo pour récupérer un token
                .then((JWT_tokens) => {
                    console.log('JWT_tokens', JWT_tokens);
                    return getFinancoAccessTokens(JWT_tokens, finm.ajax_url);
                })
                .then((accessTokens) => {
                    console.log('accessTokens', accessTokens);
                    if(Object.keys(accessTokens).length) {
                        Object.keys(accessTokens).forEach((key) => {
                            const microSimulatorPlaceholder = document.querySelector(`#${key}`);
                            
                            if(microSimulatorPlaceholder && accessTokens[key].financo_token) {
                                // Création et injection de l'iframe dans le div avec data-fws-id="financowebmicrosimu"
                                const financoMicroSimulator = document.createElement('fin-microsimu');
                                financoMicroSimulator.setAttribute('token', accessTokens[key].financo_token);
                                financoMicroSimulator.setAttribute('debug', true);

                                microSimulatorPlaceholder.classList.remove('financo-micro-simulator--loading');
                                microSimulatorPlaceholder.classList.add('financo-micro-simulator--fetched');
                                microSimulatorPlaceholder.appendChild(financoMicroSimulator);
                            }
                        });

                        setTimeout(() => document.dispatchEvent(new CustomEvent('micro-simulator:loaded')), 0);
                    }
                })
                .catch((err) => console.warn('Erreur lors de la création du micro-simulateur Financo', err));
        }
    }
}

function resizeMicroSimulators() {
    const microSimulators = document.querySelectorAll('fin-microsimu');

    if(microSimulators.length) {
        microSimulators.forEach((simulator) => {
            const rootEl = simulator.shadowRoot.querySelector('.fws-microsimu');
            
            if(rootEl) {
                const firstLine = simulator.shadowRoot.querySelector('.fws-microsimu__first');
                const number = simulator.shadowRoot.querySelector('.fws-microsimu__number');
                
                rootEl.style.minWidth = '0';

                if(document.body.classList.contains('vehicle-details-page')) {
                    rootEl.style.marginTop = '0';
                    rootEl.style.marginBottom = '10px';
                }
                else {
                    rootEl.style.marginTop = '5px';
                    rootEl.style.marginBottom = '13px';
                }
                
                if(firstLine) {
                    firstLine.style.fontSize = '14px';
                }
                if(number) {
                    number.style.fontSize = '16px';
                }

                // if(window.matchMedia('(max-width: 768px)').matches) {
                //     if(firstLine) {
                //         firstLine.style.fontSize  = '10px';
                //     }
                //     if(number) {
                //         number.style.fontSize  = '12px';
                //     }
                // } 
                // else {
                //     if(firstLine) {
                //         firstLine.style.fontSize  = '14px';
                //     }
                //     if(number) {
                //         number.style.fontSize  = '16px';
                //     }
                // }
            }
        });
    }
}

refreshMicroSimulators();
resizeMicroSimulators();
document.addEventListener('micro-simulator:refresh', refreshMicroSimulators);
document.addEventListener('micro-simulator:refresh', resizeMicroSimulators);
document.addEventListener('micro-simulator:loaded', resizeMicroSimulators);
window.addEventListener('resize', resizeMicroSimulators);
window.addEventListener('load', resizeMicroSimulators);
window.addEventListener('DOMContentLoaded', resizeMicroSimulators);